if (!customElements.get('product-offer-picker')) {
  class ProductOfferPicker extends HTMLElement {
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('.product-offer-picker__option'));
      this.inputs = Array.from(this.querySelectorAll('input[type="radio"]'));
      this.productInfo = this.closest('product-info');
      this.variantInput = this.getVariantInput();
      this.syncingVariant = false;

      this.onChange = this.onChange.bind(this);
      this.onVariantInputChange = this.onVariantInputChange.bind(this);
      this.inputs.forEach((input) => input.addEventListener('change', this.onChange));
      this.variantInput?.addEventListener('change', this.onVariantInputChange);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.productInfo?.dataset.section;
          if (event?.data?.sectionId && sectionId && event.data.sectionId !== sectionId) return;
          if (event?.data?.variant?.id) {
            this.dataset.soloVariantId = String(event.data.variant.id);
          }
          this.syncVariantInput();
        });
      }

      this.applySelection();
    }

    disconnectedCallback() {
      this.inputs.forEach((input) => input.removeEventListener('change', this.onChange));
      this.variantInput?.removeEventListener('change', this.onVariantInputChange);
      if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
    }

    getVariantInput() {
      const root = this.productInfo || document;
      return (
        root.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
        root.querySelector('input.product-variant-id')
      );
    }

    onChange() {
      this.applySelection();
    }

    onVariantInputChange() {
      if (this.syncingVariant) return;
      if (!this.isBundle() && this.variantInput?.value) {
        this.dataset.soloVariantId = this.variantInput.value;
      }
      this.syncVariantInput();
    }

    selectedValue() {
      const selected = this.inputs.find((input) => input.checked);
      return selected ? selected.value : 'solo';
    }

    isBundle() {
      return this.selectedValue() === 'bundle';
    }

    applySelection() {
      this.options.forEach((option) => {
        const input = option.querySelector('input[type="radio"]');
        option.classList.toggle('is-selected', Boolean(input?.checked));
      });

      this.syncVariantInput();
      this.updatePriceSurfaces(this.isBundle());
    }

    syncVariantInput() {
      if (!this.variantInput) this.variantInput = this.getVariantInput();
      if (!this.variantInput) return;

      const nextId = this.isBundle() ? this.dataset.bundleVariantId : this.dataset.soloVariantId;
      if (!nextId || this.variantInput.value === nextId) return;

      this.syncingVariant = true;
      this.variantInput.value = nextId;
      this.syncingVariant = false;
    }

    updatePriceSurfaces(bundleSelected) {
      const price = bundleSelected ? this.dataset.bundlePrice : this.dataset.soloPrice;
      const compare = bundleSelected ? this.dataset.bundleCompare : this.dataset.soloCompare;
      const savings = bundleSelected ? this.dataset.bundleSavings : this.dataset.soloSavings;
      const title = bundleSelected ? this.dataset.bundleTitle : this.dataset.soloTitle;
      const image = bundleSelected ? this.dataset.bundleImage : this.dataset.soloImage;

      const jubilee = this.productInfo?.querySelector('.jubilee-price');
      if (jubilee) {
        const amounts = jubilee.querySelector('.jubilee-price__amounts');
        const saleEl = jubilee.querySelector('.jubilee-price__sale');
        let compareEl = jubilee.querySelector('.jubilee-price__compare');
        if (!compareEl && amounts) {
          compareEl = document.createElement('span');
          compareEl.className = 'jubilee-price__compare';
          compareEl.appendChild(document.createElement('s'));
          const sale = amounts.querySelector('.jubilee-price__sale');
          amounts.insertBefore(compareEl, sale || amounts.firstChild);
        }
        if (saleEl && price) saleEl.textContent = price;

        if (compareEl) {
          const strike = compareEl.querySelector('s') || compareEl;
          if (compare) {
            strike.textContent = compare;
            compareEl.hidden = false;
            compareEl.style.display = '';
          } else {
            compareEl.hidden = true;
          }
        }

        const badge = jubilee.querySelector('.jubilee-price__badge');
        if (badge) {
          const label = badge.dataset.saveLabel || '';
          if (savings && label) {
            badge.textContent = `${label} ${savings}`;
            badge.hidden = false;
          } else {
            badge.hidden = true;
          }
        }
      }

      const floating = document.getElementById('floating-add-to-cart');
      if (!floating) return;

      const floatingPrice = floating.querySelector('.product__floating-price');
      if (floatingPrice && price) {
        const discount = floatingPrice.querySelector('.product__floating-right-discount');
        let priceEl = floatingPrice.querySelector('[data-offer-price]');
        if (!priceEl) {
          Array.from(floatingPrice.childNodes).forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE) node.remove();
          });
          priceEl = document.createElement('span');
          priceEl.dataset.offerPrice = '';
          floatingPrice.insertBefore(priceEl, discount || floatingPrice.firstChild);
        }
        priceEl.textContent = price;
        if (discount) discount.hidden = Boolean(bundleSelected) || !compare;
      }

      const floatingTitleWrap = floating.querySelector('.product__floating-left');
      if (floatingTitleWrap && title) {
        let titleEl = floatingTitleWrap.querySelector('[data-offer-title]');
        if (!titleEl) {
          const firstText = Array.from(floatingTitleWrap.childNodes).find(
            (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
          );
          titleEl = document.createElement('span');
          titleEl.dataset.offerTitle = '';
          if (firstText) {
            floatingTitleWrap.replaceChild(titleEl, firstText);
          } else {
            floatingTitleWrap.insertBefore(titleEl, floatingTitleWrap.firstChild);
          }
        }
        titleEl.textContent = title;
      }

      const floatingImage = floating.querySelector('.product__floating-image');
      if (floatingImage && image) floatingImage.src = image;
    }
  }

  customElements.define('product-offer-picker', ProductOfferPicker);
}
